import React from "react";
import "./Finder.css";

const audioFolders = {
  "prods": [
    { name: "prod1.wav", src: "/audio/prod1.mp3" },
    { name: "prod2.wav", src: "/audio/prod2.mp3" },
    { name: "prod3.wav", src: "/audio/prod3.mp3" },
    { name: "prod4.wav", src: "/audio/prod4.mp3" },
    { name: "prod5.wav", src: "/audio/prod5.mp3" }
  ],
  "Ã  trier": [
    { name: "musique1.wav", src: "/audio/musique1.mp3" },
    { name: "musique2.wav", src: "/audio/musique2.mp3" },
    { name: "musique3.wav", src: "/audio/musique3.mp3" }
  ]
};

export default function AudioFolder({ onClose, folderName, onPlayTrack }) {
  const files = audioFolders[folderName] || [];

  return (
    <div className="finder-overlay" onClick={onClose}>
      <div className="finder-window" onClick={(e) => e.stopPropagation()}>
        <div className="finder-topbar">
          <div className="finder-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="finder-title">{folderName}</span>
        </div>
        <div className="finder-content">
          {files.map((file, index) => (
            <div 
              key={index} 
              className="finder-file audio-file" 
              onClick={() => onPlayTrack(file, files)}
            >
              <div className="audio-icon-wrapper">
                <img src="/mp3.png" alt={file.name} />
                <div className="play-overlay">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
                    <circle cx="16" cy="16" r="16" fill="rgba(0,0,0,0.6)"/>
                    <path d="M12 8l12 8-12 8V8z" fill="white"/>
                  </svg>
                </div>
              </div>
              <span>{file.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}